<div #dialogContent></div>
<scaffold-dialog [title]="data.title">
  <div scaffoldDialogBody>
    <app-file-manager (selectFile)="setFile($event)" [allowSelection]="true" [filter]="data.filter" [source]="data.source"></app-file-manager>
    <span *ngIf="selected">{{selected.title}}</span>
  </div>
  <div scaffoldDialogButtons>
    <button pButton severity="secondary" (click)="dialogRef.close()" [disabled]="closing">{{'cancel'| translation}}</button>
    <button pButton severity="primary" (click)="selectFile()" [disabled]="!selected || closing">{{'select'| translation}}</button>
  </div>
</scaffold-dialog>
